// status-classes.ts
export const getStatusClasses = (statut: string): { [key: string]: boolean } => ({
    'badge-info': ['initialisé', 'soumis', 'appliqué', 'analysé'].includes(statut),
    'badge-danger': ['archivé', 'retourné'].includes(statut),
    'badge-success': ['arbitré', 'traité'].includes(statut),
    'badge-warning': statut === 'en attente',
    'badge-valide': statut === 'validé',
    'badge-effectue': statut === 'effectué',
    'badge-accepte': statut === 'accepté',
    'badge-planifie': statut === 'planifié',
    'badge-approuve': statut === 'approuvé',
    'badge-revus': statut === 'revu',
    'badge-soumis': statut === 'soumis',
    'badge-100': statut !== 'planifié',
  });
  